// extracted by mini-css-extract-plugin
export default {"outer-container":"SzqcEw3srG7juBqqgzxduw==","outerContainer":"SzqcEw3srG7juBqqgzxduw==","inner-container":"rHy7Vc32lKI30W82WIvUxQ==","innerContainer":"rHy7Vc32lKI30W82WIvUxQ=="};